import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-sortable-handle]",
      ghostClass: "opacity-50",
      onEnd: this.updatePositions.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  updatePositions() {
    this.itemTargets.forEach((item, index) => {
      const positionInput = item.querySelector("[data-position-field]")
      if (positionInput) {
        positionInput.value = index + 1
      }
    })
  }
}
